import { IS_WECHAT } from '../util/ua';
import { getScript } from '../util/getScript';


export async function getWxBridge(): Promise<Wx.WeixinJSBridge | undefined> {
  let wxJSBridgePromise: Promise<Wx.WeixinJSBridge> | undefined;
  if (IS_WECHAT) {
    wxJSBridgePromise = new Promise<Wx.WeixinJSBridge>((resolve, reject) => {
      // 如果已经存在了，直接resolve
      if (window.WeixinJSBridge) {
        resolve(window.WeixinJSBridge);
        return;
      }

      // 监听WeixinJSBridge
      const timer = setTimeout(() => {
        reject('WeixinJSBridge timeout');
      }, 8000);
      document.addEventListener('WeixinJSBridgeReady', () => {
        clearTimeout(timer);
        if (window.WeixinJSBridge) {
          resolve(window.WeixinJSBridge);
        } else {
          reject('WeixinJSBridge not found');
        }
      });
    });
  }

  const bridge = await wxJSBridgePromise;

  if (!window.WeixinJSBridge) {
    return Promise.reject('couldn\'t access WeixinJSBridge');
  }
  return Promise.resolve(bridge);
}

export async function getMqqApi(): Promise<Mqq.MqqApi | undefined> {
  let mqqScriptPromise: Promise<Mqq.MqqApi> | Mqq.MqqApi | undefined;
  if (!window.mqq) {
    mqqScriptPromise = getScript<Mqq.MqqApi>('//s.url.cn/qqmobile/qqapi.js?_bid=152', window, 'mqq');
  } else {
    mqqScriptPromise = window.mqq;
  }
  return mqqScriptPromise;
}
